import {FC} from 'react'
import {useTranslation} from '@/translations/i18n'
import {DetailsSidebar, DetailsSidebarTabs} from '@/components/ui/details-atoms/DetailsAtoms'
import {ListIcon} from '@/components/ui/icon/Icon'
import {Button} from '@/components/ui/button/Button'
import {ActivityLogsList} from '@/features/entity-activity-logs/components/activity-logs-list/ActivityLogsList'
import {EntityUrlType, ActivityLogsQueryParams} from '@/features/entity-activity-logs/types'

interface EntityActivityLogsProps {
    entityType: EntityUrlType
    entityId?: string
    queryParams?: Omit<ActivityLogsQueryParams, 'page'>
}

export const EntityActivityLogs: FC<EntityActivityLogsProps> = ({entityType, entityId, queryParams}) => {
    const {t} = useTranslation()

    return (
        <DetailsSidebar>
            <DetailsSidebarTabs>
                <Button variant="ghost" size="sm" shape="roundedRectangle">
                    <ListIcon />
                    {t('commons:activities')}
                </Button>
            </DetailsSidebarTabs>

            <ActivityLogsList entityType={entityType} entityId={entityId} queryParams={queryParams} />
        </DetailsSidebar>
    )
}
